import styled from "styled-components";
import { Ptag } from "components/core";
export const OuterBox = styled.div`
   padding: 1.4rem 2rem;
   margin-bottom: 2.2rem;
   width:100%;
   border-radius:10px;
   background: ${props => props.theme.headerBackgroundColor};
`
// export const Label = styled.Ptag`
//    fontSize:20px;
// `